<template>
    <div id="asjnfhabfha">
        <Loading v-show="loading"></Loading>

        <div v-show="!loading">
            <div style="display: flex;justify-content: center;">
                <button @click="dmIndex -= 500; changePageIndex(-1)">《《《</button>
                <button @click="dmIndex -= 100; changePageIndex(-1)">《《</button>
                <button @click="dmIndex -= 50; changePageIndex(-1)">《</button>
                {{ dmIndex + 1 }}&nbsp;|&nbsp;{{  filteredDomains?  filteredDomains.length : -1}}
                <button @click="dmIndex += 50; changePageIndex(1)">》</button>
                <button @click="dmIndex += 100; changePageIndex(1)">》》</button>
                <button @click="dmIndex += 500; changePageIndex(1)">》》》</button>
                <button @click="sortSettingSwitch">设置</button>

            </div>
            <div>
                <input v-model="keywordInputing" type="text" name="" id="">
                <button @click="resetFilter">清除</button>
                <button @click="startFilter">过滤</button>
            </div>
            <div v-if="isSetting">
                <div>
                    <label>
                        <input type="radio" v-model="isAsc" :value="1"> asc
                    </label>
                    <label>
                        <input type="radio" v-model="isAsc" :value="0"> desc
                    </label>
                    {{ isAsc }}
                </div>
                <div>
                    <label>
                        <input type="radio" v-model="field" :value="0"> 过期
                    </label>
                    <label>
                        <input type="radio" v-model="field" :value="1"> 注册
                    </label>
                    <label>
                        <input type="radio" v-model="field" :value="2"> 扫描
                    </label>
                    <label>
                        <input type="radio" v-model="field" :value="3"> 审查
                    </label>
                    {{ field }}
                </div>

            </div>

            <a target="_blank" :href="`http://${dm.name}.com`" ref="MainBannerWrapper2" id="MainBannerWrapper2">
                <div id="domainName">
                    {{ dm.name }}
                </div>
            </a>
            <div id="moreInfo">
                <a target="_blank" title="icann whois"  :href="`https://lookup.icann.org/whois/en?q=${dm.name}.com&t=a`">
                    <img src="https://assets.apilayer.com/apis/whois.png" alt="">
                </a>
                <a title="google without tld" target="_blank" :href="`https://www.google.com.hk/search?q=${dm.name}`">
                    <img src="https://m.media-amazon.com/images/I/41HeL2cy9LL.png" alt="">
                </a>
                <a title="google with tld" target="_blank" :href="`https://www.google.com.hk/search?q=${dm.name}.com`">
                    <img src="https://m.media-amazon.com/images/I/41HeL2cy9LL.png" alt="">
                </a>
            </div>
            <table
                v-if="1"    
            >

                <tbody>

                    <tr v-for="(label, key) in timeFields" :key="key">
                        <td>{{ label }}</td>
                        <td>{{ formatTime(dm[key]) }}</td>
                    </tr>

                    
                </tbody>
            </table>

            <div id="attPanel">

                <div id="whoisControl">
                    <div class="controlBt" @click="whoisNow">更新</div>
                    <div class="controlBt" @click="retrieveOne">刷新</div>
                </div>
                <div id="infoControl">
                    <div @click="isAddingInfo = !isAddingInfo" v-if="!isAddingInfo">
                        {{ dm.info ? dm.info : "添加备注" }}
                    </div>
                    <div v-else>
                        <input v-model="AddingInfo" placeholder="添加备注" type="text" />
                        <button @click="isAddingInfo = !isAddingInfo; cancleUpateInfo()">取消</button>
                        <button @click="isAddingInfo = !isAddingInfo; confirmUpateInfo()">确认</button>
                    </div>

                </div>
                <div>
                    <div class="controlBt" id="concernControl" @click="changeConcern">关注 {{ dm.concern }}</div>
                </div>
                <div id="delControl">
                    <div class="controlBt" v-if="!confirmDel" @click="confirmDel = true">删除</div>
                    <template v-if="confirmDel">

                        <div class="controlBt" @click="confirmDel = false">取消删除</div>
                        <div class="controlBt" style="color: red;font-weight: bold;" @click="confirmDelExe">确认删除</div>
                    </template>


                </div>

                <div id="indexControl">
                    <div class="controlBt" @click="changePageIndex(-1)">上一个</div>
                    <div class="controlBt" @click="examine">检查</div>
                    <div class="controlBt" @click="changePageIndex(1)">下一个</div>
                </div>

            </div>
            <div >
                        <input v-model="domainToBeInsert" placeholder="添加domain" type="text" />
                        <button @click=" domainToBeInsert = ''">取消</button>
                        <button @click=" domainInsert()">确认</button>
            </div>
        </div>

    </div>

</template>

<script>
import Loading from './Loading.vue'

import { getRandomBackground } from '../components/gd'

export default {
    components: {
        Loading,
    },
    data() {
        return {
            orDms:[],
            // dmsForView: [],
            dm: {},
            dmIndex: 0,
            pageSize: 100,
            loading: true,
            isAddingInfo: false,
            AddingInfo: '',
            batchSize: 30,

            confirmDel: false,
            isSetting: false,
            isAsc: 1,
            field : 3,
            domainToBeInsert:'',
            timeFields: {
                    exTime: 'exTime',
                    regTime: 'regTime',
                    scanTime: 'scanTime',
                    examineTime: 'examineTime'
                },
            keywordInputing:"",
            keyword:"",
        }
    },
    methods: {
        startFilter(){
            this.keyword = this.keywordInputing
            this.dmIndex = 0
        },
        resetFilter(){
            this.keyword = "";
            this.keywordInputing = ""
        },
        formatTime(value) {
            return value ? value.slice(0, -10) : '—'; // 如果为空显示占位符
        },
        sortSettingSwitch() {
            this.isSetting = !this.isSetting
            if(this.isSetting == false){
                this.myInitButton()
            }
        },
        randomBg() {
            const q = getRandomBackground()
            this.$refs.MainBannerWrapper2.style.backgroundImage = q.gradient
        },
        cancleUpateInfo() {
            this.AddingInfo = ""
        },


        examine(){      // 我检查过了
            this.loading = true
            this.$axios.get(`/api/dm/has-examine/${this.dm.id}`)
                .then(res => {
                    this.retrieveOne()
                })
        },

        domainInsert(){
            // 像backend做提交, 添加一个或一组name
            this.loading = true
            this.$axios.get(`/api/dm/add-with-whois/${this.domainToBeInsert}`)
                .then(res => {
                    this.loading = false
                    this.domainToBeInsert = ''
                })
                .catch(err=>{
                    //Todo
                })
        },

        initdmsForView() {
            ;//console.log("initdmsForView...")
            this.$axios.post("/api/dm/get/simple",{asc:this.isAsc,sort:this.field})
                .then(res => {
                    ;//console.log(res)
                    this.orDms = res.data
                    this.orDms.forEach(obj => {
                        obj.isSimple = true;    //前端字段
                        obj.fielted = false;    //前端字段
                    })
                    // this.dmsForView = this.orDms


                    this.fillDmFromNet();
                })
            ;//console.log("initdmsForViewed")
            
        },
        confirmDelExe() {
            // return ; // 暂时先不启用
            this.loading = true
            this.$axios.get(`/api/dm/del/one/${this.dm.id}`)
                .then(res => {
                    // this.filteredDomains.splice(this.dmIndex, 1);      //Todo 删除源头, view自动computed
                    this._deleteDmInMem(this.dm.id,this.orDms)
                    this.confirmDel = false
                    this.dm = this.filteredDomains[this.dmIndex]
                    this.loading = false

                })
                .catch(err=>{
                    //Todo
                })
        },
        confirmUpateInfo() {
            // Todo
            this.dm.info = this.AddingInfo
            this.updateNow().then(_ => {
                this.AddingInfo = ""
            })
        },
        _fillDmInMem(id,singleData,set){
            console.log(singleData)
            let index = 0;
            for (; index < set.length; index++) {
                if (set[index].id == id) {
                    this.$set(set, index, { ...singleData, isSimple: false });
                    return;
                }
            }
        },
        _deleteDmInMem(id,set){
            let index = -1;
            for(let i = 0; i < set.length;i++){
                if(set[i].id == id){
                    index = i
                    break
                }
            }
            set.splice(index,1)
        },
        fillDmFromNet() {       //Todo
            ;//console.log("fetching...")
            this.loading = true
            let ids = [];
            let i = this.dmIndex - 2 * this.batchSize;
            console.log(2414121)
            // Todo 可以大胆地认为, 过滤后相近的数据, 在原来的列表中也是相临的
            for (; i < this.filteredDomains.length && i < this.dmIndex + 2 * this.batchSize; i++) {
                if (i < 0) {
                    continue
                }
                let hasLoaded = this.isThisDmHasLoadedFromNet(i)
                if (hasLoaded) {
                    continue
                }
                ids.push(this.filteredDomains[i].id)
            }
            ;//console.log(2414122221)


            if (ids.length == 0) {
                return
            }
            this.$axios.post(`/api/dm/get/mul`, ids)
                .then(res => {
                    // //console.log(res)
                    // this.ids = res.data

                    ;//console.log(res.data)

                    res.data.forEach(dm => {
                        let id = dm.id
                        console.log("ddgg")
                        // let index = 0;
                        // for (; index < this.orDms.length; index++) {
                        //     if (this.orDms[index].id == id) {
                        //         this.$set(this.orDms, index, { ...dm, isSimple: false });
                        //         return;
                        //     }
                        // }
                        // this._fillDmInMem(id,dm,this.dmsForView)
                        this._fillDmInMem(id,dm,this.orDms)
                    })

                    // this.$set(this.dmsForView, this.dmIndex, { ...res.data, isSimple: false });
                    this.dm = this.filteredDomains[this.dmIndex]        // 又是耦合了
                    this.loading = false
                })
            ;//console.log("fetched")

        },
        fillDmFromNetOld() {    //Deprecated
            return
            let id = this.dmsForView[this.dmIndex].id
            this.$axios.get(`/api/dm/get/one/${id}`)
                .then(res => {
                    // ;//console.log(res)
                    // this.ids = res.data
                    this.$set(this.dmsForView, this.dmIndex, { ...res.data, isSimple: false });
                    this.dm = this.dmsForView[this.dmIndex]
                })
        },
        changeConcern() {
            this.dm.concern = !this.dm.concern

            this.updateNow()
        },
        whoisNow() {
            // 需要手动刷新
            this.loading = true
            this.$axios.get(`/api/dm/update-whois/${this.dm.id}`)
                .then(res => {
                    this.loading = false
                })
        },
        retrieveOne() {

            this.loading = true
            this.$axios.get(`/api/dm/get/one/${this.dm.id}`)
                .then(res => {
                    this.loading = false
                    let dm = res.data
                    let id = res.data.id
                    // let index = 0;
                    // // 更新两个列表
                    // for (; index < this.orDms.length; index++) {
                    //     if (this.orDms[index].id == id) {
                    //         this.$set(this.orDms, index, { ...dm, isSimple: false });
                    //         break;
                    //     }
                    // }
                    this._fillDmInMem(id,dm,this.orDms)

                    // index = 0
                    // for (; index < this.dmsForView.length; index++) {
                    //     if (this.dmsForView[index].id == id) {
                    //         this.$set(this.dmsForView, index, { ...dm, isSimple: false });
                    //         break;
                    //     }
                    // }     
                    this.dm = this.orDms[this.dmIndex]

                })
        },
        updateNow() {
            this.loading = true
            return this.$axios.post(`/api/dm/update/one`, this.dm)
                .then(res => {
                    this.fillDmFromNet()
                    this.loading = false
                })

        },
        changePageIndex(direction) {
            // checked
            let cur = this.dmIndex;
            if (direction > 0) {
                cur++;
            } else {
                cur--;
            }
            if (cur == this.filteredDomains.length || cur == -1) {
                return
            }
            this.dmIndex = cur;
        },
        isThisDmHasLoadedFromNet(indexOfList) {
            // Todo 这个可能需要修改, 因为过滤后的数据, 是不靠谱的!
            ;//console.log("isThisDmHasLoadedFromNet")

            if (indexOfList >= this.filteredDomains.length || indexOfList < 0) {
                return true; //保守一点
            }
            let obj = this.filteredDomains[indexOfList]
            return !obj.isSimple
        },
        myInitButton(){
            this.initdmsForView();
            this.randomBg()
        }
    },
    mounted() {
        this.myInitButton()
        // this.initFirstPage();
    },
    computed:{

        filteredDomains(){
            // Todo 初始化需要调用一次!
            let result = this.orDms;
            const keyword = this.keyword.toLowerCase();
            if(!keyword){
                console.log("没有过滤条件")
                return result
            }else{
                console.log("使用关键字过滤: ",keyword);
                result = result.filter(item => {
                    let name = `${item.name}`
                    return name.toString().toLowerCase().includes(keyword)
                });
            }
            this.loading = false
            console.log(123677)
            console.log(result)
            return result
        }
    },
    watch: {
        dmIndex(_, __) {
            this.randomBg()

            console.log("开始dmIndex的watcher")
            console.log(this.filteredDomains.length)
            console.log(56789)
            this.dm = this.filteredDomains[this.dmIndex]
            console.log(5672289)

            console.log(this.filteredDomains.length)
            console.log(this.dm)

            let hasLoadedCur = this.isThisDmHasLoadedFromNet(this.dmIndex)
            let hasLoadedCurL = this.isThisDmHasLoadedFromNet(this.dmIndex - this.batchSize)
            let hasLoadedCurR = this.isThisDmHasLoadedFromNet(this.dmIndex + this.batchSize)

            //  Todo 逻辑错误, 过滤后的数据无序, 使用fillDmFromNet可能会加载不需要的数据

            if (hasLoadedCur && hasLoadedCurL && hasLoadedCurR) {
                return
            }
            ;//console.log("fucks")
            this.fillDmFromNet()
        }
    }
}
</script>



<style lang="less" scoped>
#asjnfhabfha {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 20px;
    margin-top: 20px;
}

#MainBannerWrapper2 {

    margin: 10px;
    display: block;
    text-decoration: none;

    #domainName {
        color: aliceblue;
        font-size: 36px;
        font-weight: bolder;
        font-family: jetbrainmono, afont, serif;
        backdrop-filter: blur(10px);
        background-color: rgba(0, 0, 0, 0.387);
        text-align: center;
    }
}

#attPanel {

    >div {
        margin: 5px;
        display: flex;
        justify-content: space-around;
    }

    .controlBt {
        text-align: center;
        border: 1px solid wheat;
        border-radius: 5px;
        padding: 5px 10px;
        margin: 5px;
    }
}
#moreInfo{
    img{
        width: 50px;
    }
    display: flex;
    justify-content: center;
}
</style>